import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {SubmitButtonComponent} from "../../../components/submit-button/submit-button.component";
import {PaymentService} from '../payment.service';
import {DynamicDialogRef} from "primeng/dynamicdialog";

@Component({
  selector: 'homey-not-paid-dialog',
  imports: [
    SubmitButtonComponent
  ],
  templateUrl: './not-paid-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotPaidDialogComponent {
  private readonly paymentService = inject(PaymentService);
  private readonly dialogRef = inject(DynamicDialogRef)
  protected readonly submit = async () => {
    this.dialogRef.close();
    this.paymentService.openResubscribeDialog();
  }
}
